import { Component, type ErrorInfo, type ReactNode } from 'react';

type Props = { children: ReactNode };
type State = { hasError: boolean };

export class AppErrorBoundary extends Component<Props, State> {
  public state: State = { hasError: false };

  public static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  public componentDidCatch(error: Error, info: ErrorInfo): void {
    if (import.meta.env.DEV) {
      console.error('Application render failed', error, info.componentStack);
    }
  }

  public render(): ReactNode {
    if (this.state.hasError) {
      return (
        <main className="state-page" role="alert">
          <p className="eyebrow">Something went wrong</p>
          <h1>We could not load this page.</h1>
          <p>Please refresh and try again.</p>
          <button
            className="button"
            onClick={() => {
              window.location.reload();
            }}
            type="button"
          >
            Refresh page
          </button>
        </main>
      );
    }

    return this.props.children;
  }
}
